import { generateRandomString, escape, unescape } from 'lib/utils/string';

export default {
  props: {
    value: [
      Number,
      String,
    ],
    type: {
      type: String,
      default: () => 'text',
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    validation: {
      type: Function,
      default: undefined,
    },
    mask: {
      type: [Array, Boolean],
      default: () => false,
    },
  },
  data() {
    return {
      internalValue: '',
      internalError: false,
      isEditing: false,
      focused: false,
    };
  },
  computed: {
    inputId() {
      return generateRandomString();
    },
    isInvalid() {
      return this.internalError && this.isEditing;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isEditing = val.length > 0;
        this.internalValue = unescape(val);
      },
    },
    internalValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', escape(val), val);
      },
    },
    error: {
      immediate: true,
      handler(val) {
        this.internalError = val;
      },
    },
  },
  methods: {
    handleBlur() {
      this.$emit('blur');
      this.validate();
      this.focused = false;
    },
    handleFocus() {
      this.$emit('focus');
      this.focused = true;
    },

    validate() {
      if (this.$validate.isUndefined(this.validation)) {
        return;
      }

      const trimedValue = this.internalValue.trim();
      const isValid = this.validation(trimedValue);

      this.internalError = !isValid;
    },
  },
};
